import React from "react";
import { Box } from "native-base";

export default function Spacer() {
  return <Box h={12} />;
}
